import React from 'react'
import store from './redux/index'
import { Provider } from 'react-redux'
import { HashRouter, useLocation } from 'react-router-dom'
import App from './App'

export default class Root extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <HashRouter>
          <Location>
            {(location) => {
              return <App {...this.props} location={location} />
            }}
          </Location>
        </HashRouter>
      </Provider>
    )
  }
}

function Location({ children }) {
  let location = useLocation()
  return children(location)
}
